import React from 'react'

import { cn } from '@/utilities/ui'

import { promotionBadgeBaseClassName } from './promotionBadgeStyles'

export type PromotionBadgeVariant = 'permanent' | 'timed'

const badgeStyles: Record<
  PromotionBadgeVariant,
  { className: string; labelClassName: string }
> = {
  permanent: {
    className:
      'border-transparent bg-pink-wash shadow-[0_6px_20px_rgba(174,0,255,0.12)]',
    labelClassName: 'text-[#49225B]',
  },
  timed: {
    className: 'border-transparent bg-[#FFA75A]',
    labelClassName: 'text-[#400000]',
  },
}

export type PromotionBadgeProps = {
  label: string
  variant: PromotionBadgeVariant
}

export function PromotionBadge({ label, variant }: PromotionBadgeProps) {
  const styles = badgeStyles[variant]

  return (
    <span
      className={cn(
        promotionBadgeBaseClassName,
        variant === 'timed' ? 'shadow-[0_6px_20px_rgba(9,114,82,0.12)]' : null,
        styles.className,
        styles.labelClassName,
      )}
    >
      {label}
    </span>
  )
}
